var pug = require("!../../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {


















pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};






































pug_html = pug_html + "\u003Ch2\u003ECreate investment product{{ vm.isRequired }}\u003C\u002Fh2\u003E\u003Cform layout=\"column\" layout-padding flex name=\"vm.createForm\" api-form=\"vm.confirmAction()\"\u003E\u003Cinput-container label=\"Name\"\u003E\u003Cinput required name=\"name\" ng-model=\"vm.name\"\u003E\u003C\u002Finput-container\u003E\u003Cdiv\u003E\u003Cp class=\"label required\"\u003EProduct type\u003C\u002Fp\u003E";
pug_mixins["required-radio-container"].call({
block: function(){
pug_html = pug_html + "\u003Cmd-radio-button value=\"standard\"\u003EStandard\u003C\u002Fmd-radio-button\u003E\u003Cmd-radio-button value=\"rolling\"\u003ERolling\u003C\u002Fmd-radio-button\u003E";
}
}, "type", "vm.type");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Cbranding-colour-selection branding-id=\"vm.brandingId\" required=\"true\"\u003E\u003C\u002Fbranding-colour-selection\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cinput-container label=\"Start date\" always-show-errors=\"true\"\u003E\u003Cinput required name=\"startDate\" ng-model=\"vm.startDate\" type=\"date\"\u003E\u003Cng-message when=\"date\"\u003EMust be valid date\u003C\u002Fng-message\u003E\u003Cng-message when=\"range\"\u003ECannot be before today\u003C\u002Fng-message\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"Estimated investment start date\" always-show-errors=\"true\"\u003E\u003Cinput required name=\"estimatedStartDate\" ng-model=\"vm.estimatedStartDate\" type=\"text\"\u003E\u003C\u002Finput-container\u003E\u003Cbr\u003E\u003Cinput-container label=\"Target return\"\u003E\u003Cinput required name=\"targetRate\" string-to-number ng-model=\"vm.targetRate\" type=\"number\" min=\"00.00\" step=\"0.01\" pattern=\"\\d{1,}(\\.\\d{1,2})?\"\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"Unit price\"\u003E\u003Cinput required name=\"unitPrice\" string-to-number ng-model=\"vm.unitPrice\" type=\"number\" min=\"00.00\" step=\"0.01\" pattern=\"\\d{1,}(\\.\\d{1,2})?\"\u003E\u003C\u002Finput-container\u003E\u003Cbr\u003E\u003Cinput-container label=\"Investment term (in months)\"\u003E\u003Cinput required type=\"number\" name=\"commitmentPeriod\" ng-model=\"vm.commitmentPeriod\" min=\"1\" max=\"84\" step=\"1\"\u003E\u003Cng-message when=\"min\"\u003EMust be at least 1\u003C\u002Fng-message\u003E\u003Cng-message when=\"max\"\u003EMust be less than 84\u003C\u002Fng-message\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"Minimum initial investment amount\"\u003E\u003Cinput required type=\"number\" name=\"minimumInitialInvestmentAmount\" ng-model=\"vm.minimumInitialInvestmentAmount\" min=\"50\" step=\"50\"\u003E\u003Cng-message when=\"min\"\u003EMust be at least $50\u003C\u002Fng-message\u003E\u003Cng-message when=\"step\"\u003EMust be multiple of $50\u003C\u002Fng-message\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"Minimum additional investment amount\"\u003E\u003Cinput required type=\"number\" name=\"minimumAdditionalInvestmentAmount\" ng-model=\"vm.minimumAdditionalInvestmentAmount\" min=\"50\" step=\"50\"\u003E\u003Cng-message when=\"min\"\u003EMust be at least $50\u003C\u002Fng-message\u003E\u003Cng-message when=\"step\"\u003EMust be multiple of $50\u003C\u002Fng-message\u003E\u003C\u002Finput-container\u003E\u003Cbr\u003E\u003Cinput-container label=\"Redemption notice period (in days)\"\u003E\u003Cinput required name=\"redemptionNoticePeriod\" ng-model=\"vm.redemptionNoticePeriod\" min=\"30\" step=\"1\"\u003E\u003Cng-message when=\"min\"\u003EMust be at least 30\u003C\u002Fng-message\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"Early redemption fee rate\"\u003E\u003Cinput required name=\"earlyRedemptionFeeRate\" string-to-number ng-model=\"vm.earlyRedemptionFeeRate\" type=\"number\" min=\"00.00\" step=\"0.01\" pattern=\"\\d{1,}(\\.\\d{1,2})?\"\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"Maturity redemption fee rate\"\u003E\u003Cinput required name=\"maturityRedemptionFeeRate\" string-to-number ng-model=\"vm.maturityRedemptionFeeRate\" type=\"number\" min=\"00.00\" step=\"0.01\" pattern=\"\\d{1,}(\\.\\d{1,2})?\"\u003E\u003C\u002Finput-container\u003E\u003Cbr\u003E\u003Cdiv class=\"actions\" layout=\"row\"\u003E\u003Cmd-button class=\"md-raised md-primary create\" type=\"submit\"\u003ECreate!\u003C\u002Fmd-button\u003E\u003Cmd-button class=\"md-raised cancel\" type=\"button\" ng-click=\"vm.cancelAction()\"\u003ECancel\u003C\u002Fmd-button\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E";}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;